import React from 'react';
import Icon, { IconProps } from '../Icon';

const CogsFilledIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0488 30H17.9535C18.6453 30 19.2307 29.505 19.3128 28.8612L19.8224 25.3988C20.495 25.1025 21.1561 24.7288 21.8249 24.2638L25.1751 25.5737C25.8131 25.815 26.5447 25.56 26.8656 24.9875L29.8256 20.0012C30.153 19.4163 30.0092 18.6975 29.4803 18.2887L26.6487 16.1325C26.6859 15.8 26.7154 15.4113 26.7154 15C26.7154 14.5887 26.6846 14.2 26.6487 13.8675L29.4829 11.71C30.0092 11.305 30.1542 10.5863 29.8179 9.9875L26.8733 5.02625C26.5511 4.455 25.8285 4.19375 25.17 4.43L21.8287 5.73625C21.1895 5.28625 20.5181 4.90625 19.8237 4.6025L19.3154 1.15125C19.2319 0.495 18.6466 0 17.9548 0H12.0501C11.3582 0 10.7729 0.495 10.6908 1.13875L10.1812 4.6025C9.50855 4.89875 8.84749 5.2725 8.17873 5.7375L4.82849 4.4275C4.18796 4.18375 3.45887 4.44125 3.13796 5.01375L0.189496 9.9825C-0.158365 10.555 -0.0158831 11.2975 0.523236 11.7125L3.35489 13.8675C3.30997 14.29 3.28815 14.6562 3.28815 15C3.28815 15.3438 3.30997 15.71 3.35233 16.1325L0.518101 18.2913C-0.00689779 18.6963 -0.150663 19.415 0.184361 20.0138L3.12898 24.975C3.4486 25.545 4.16999 25.805 4.83234 25.5713L8.17359 24.265C8.81283 24.7137 9.48545 25.0938 10.1799 25.3988L10.6882 28.8487C10.7716 29.505 11.357 30 12.0488 30ZM15 19.2857C17.3669 19.2857 19.2857 17.3669 19.2857 15C19.2857 12.6331 17.3669 10.7143 15 10.7143C12.6331 10.7143 10.7143 12.6331 10.7143 15C10.7143 17.3669 12.6331 19.2857 15 19.2857Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default CogsFilledIcon;
